;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export interface PublicHoliday {
  id: number;
  country_id: number;
  country_code: string;
  name: string;
  date: string;
  yearly_renewed: boolean;
  location: string;
  created_at: string;
  updated_at: string;
}

export type CreatePublicHoliday = {
  country_id: number;
  name: string;
  date: string;
  yearly_renewed: boolean;
  location: string;
};

export type AnnualLeave = {
  id: number;
  country_id: number;
  min_days: number;
  carry_over_enabled: boolean;
  carry_over_days_date: string;
  carry_over_info: string;
  created_at: string;
  updated_at: string;
};

export type CreateAnnualLeave = {
  country_id: number;
  min_days: number;
  carry_over_enabled: boolean;
  carry_over_days_date: string;
  carry_over_info: string;
};
